import React, { useEffect, useState } from "react";
import { OrganizationGraph, DecompositionTreeGraph } from "@ant-design/graphs";
import UnitDetailsModal from "../modal/UnitDetailsModal";
import { GetOrgTreeDataApi } from "../../api/GetOrgTreeDataApi";
import { GetOrganizationLevelsApi } from "../../api/org-levels/GetOrganizationLevelsApi";
import PageLoader from "../sub/PageLoader";
import { WarningOutlined } from "@ant-design/icons";

const OrganizationTree = () => {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [orgLevels, setOrgLevels] = useState();
  const [treeData, setTreeData] = useState();
  const [unitId, setUnitId] = useState("");
  const proHeight = document.body.clientHeight;

  useEffect(() => {
    getTreeData();
    getOrganizationLevels();
  }, []);

  async function getTreeData() {
    const apiResponse = await GetOrgTreeDataApi();
    if (apiResponse.message === "success") {
      setTreeData(apiResponse.units);
      if (apiResponse.units?.children?.length) {
        setCanShow(true);
      }
    }
  }

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    if (apiResponse.message === "success") {
      setOrgLevels(apiResponse.levels);
      setCanStart(true);
    }
  }

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    orgLevels?.forEach((level) => {
      if (level.id === node.level) {
        nodeColor = level.color;
      }
    });
    return nodeColor;
  }

  function selectUnit(id) {
    setUnitId(id);
    setDetailsModal(true);
  }

  function showEmpty() {
    return (
      <div
        style={{ height: proHeight - 188 }}
        className="flex justify-center items-center w-full h-full"
      >
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No structure available
          </div>
          <div className="mb-3 text-gray-400">There are no children</div>
        </div>
      </div>
    );
  }

  const config = {
    data: treeData,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
      size: [180, 23],
    },
    edgeCfg: {
      type: "polyline",
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    autoFit: false,
  };

  return canStart ? (
    canShow ? (
      <>
        <div className="border">
          {/* <OrganizationGraph
            height={proHeight - 172}
            data={treeData}
            nodeCfg={{
              style: (node) => {
                return { stroke: getNodeColor(node), cursor: "pointer" };
              },
              label: {
                style: {
                  cursor: "pointer",
                },
              },
            }}
            onReady={(graph) => {
              graph.on("node:click", (evt) => {
                selectUnit(evt.item._cfg.id);
              });
            }}
          /> */}

          <DecompositionTreeGraph
            {...config}
            onReady={(graph) => {
              graph.on("node:click", (evt) => {
                selectUnit(evt.item._cfg.id);
              });
            }}
          />
        </div>
        <UnitDetailsModal
          unitId={unitId}
          visible={detailsModal}
          handleCancel={() => {
            setDetailsModal(false);
            setUnitId("");
          }}
        />
      </>
    ) : (
      showEmpty()
    )
  ) : (
    <PageLoader />
  );
};

export default OrganizationTree;
